module.exports = __webpack_public_path__ + "static/media/ic-lamp.a047b380.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-lamp.svg
// module id = 634
// module chunks = 14